import { maxLength, required } from 'vuelidate/lib/validators'

const companyModel = {
  companyName: {
    required,
    maxLength: maxLength(256)
  },
  street: {
    required,
    maxLength: maxLength(256)
  },
  houseNumber: {
    required,
    maxLength: maxLength(256)
  },
  zipCode: {
    required,
    maxLength: maxLength(256)
  },
  city: {
    required,
    maxLength: maxLength(256)
  },
  state: {
    required,
    maxLength: maxLength(256)
  }
}

export const contractorModel = {
  form: companyModel
}
export const employerModel = {
  form: companyModel
}
